<ng-container
  *ngIf="learningObjectiveOrders$ | async as learningObjectiveOrders"
>
  <ng-container *ngIf="learningObjectiveData$ | async as learningObjectiveData">
    <ng-container
      *ngIf="learningObjectiveFilters$ | async as learningObjectiveFilters"
    >
      <ng-container *ngIf="!router.includes('/domains')">
        <div class="d-flex">
          <div class="">
            <div class="btn-group align-items-center w-100 mb-3">
              <button
                type="button"
                class="btn btn-white d-flex align-items-center"
                (click)="showHideLOFilters()"
                [class.btn-white-active]="showLearningObjFilters"
              >
                Leerdoelen <span class="mdi mdi-chevron-down ml-auto"></span>
              </button>
            </div>
            <ng-container *ngIf="showLearningObjFilters">
              <div class="filters-learningobjectives mb-3">
                <div class="btn-group w-100 mb-3">
                  <div class="form-check">
                    <input
                      type="radio"
                      id="customRadio1"
                      name="customRadio"
                      class="form-check-input"
                      [value]="1"
                      [(ngModel)]="learningObjectiveFilter"
                      (change)="changeLoFilter($event)"
                    />
                    <label class="form-check-label" for="customRadio1"></label>
                  </div>
                  <div class="dropdown-wrapper position-relative d-flex w-100">
                    <button
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="btn btn-white d-flex align-items-center w-100"
                    >
                      <span class="mr-1">Ref. niveau: </span>
                      <b>{{ refLevelPlaceholder$ | async }}</b>
                      <span class="mdi mdi-chevron-down ml-auto"></span>
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      role="menu"
                    >
                      <label
                        *ngFor="
                          let checkbox of learningObjectiveFilters.referencelevelfilter
                        "
                        role="menuitem"
                        class="form-check-label w-100"
                        [for]="checkbox.id"
                      >
                        <div class="form-check form-check-inline dropdown-item">
                          <input
                            class="form-check-input"
                            type="radio"
                            [id]="checkbox.id"
                            [value]="checkbox.value"
                            [checked]="checkbox.checked"
                            (change)="
                              changeReferenceLevelAP(
                                $event,
                                $event.target.checked,
                                checkbox.id
                              )
                            "
                          />
                          <label class="form-check-label" [for]="checkbox.id">
                            {{ checkbox.name }}</label
                          >
                        </div>
                      </label>
                    </ul>
                  </div>
                </div>
                <ng-container *ngIf="(selectedCitoModule$ | async) === 0">
                  <div class="btn-group w-100 mb-3">
                    <div class="form-check">
                      <input
                        type="radio"
                        id="customRadio2"
                        name="customRadio2"
                        class="form-check-input"
                        [value]="2"
                        [(ngModel)]="learningObjectiveFilter"
                        (change)="changeLoFilter($event)"
                      />
                      <label
                        class="form-check-label"
                        for="customRadio2"
                      ></label>
                    </div>
                    <div
                      class="dropdown-wrapper position-relative d-flex w-100"
                    >
                      <button
                        id="dropdownMenuButton2"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        type="button"
                        class="btn btn-white d-flex align-items-center w-100"
                      >
                        <span class="mr-1">Leerroute: </span>
                        <b>{{ learningroutePlaceholder$ | async }}</b>
                        <span class="mdi mdi-chevron-down ml-auto"></span>
                      </button>
                      <ul
                        aria-labelledby="dropdownMenuButton2"
                        class="dropdown-menu"
                        role="menu"
                      >
                        <label
                          *ngFor="
                            let checkbox of learningObjectiveFilters.learningroutefilter
                          "
                          role="menuitem"
                          class="form-check-label w-100"
                          [for]="checkbox.id"
                        >
                          <div
                            class="form-check form-check-inline dropdown-item"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              [id]="checkbox.id"
                              [value]="checkbox.value"
                              [checked]="checkbox.checked"
                              (change)="
                                changeReferenceLevelLR(
                                  $event,
                                  $event.target.checked,
                                  checkbox.id
                                )
                              "
                            />
                            <label class="form-check-label" [for]="checkbox.id">
                              {{ checkbox.name }}</label
                            >
                          </div>
                        </label>
                      </ul>
                    </div>
                  </div>
                </ng-container>
                <div class="btn-group w-100 mb-3">
                  <div class="form-check">
                    <input
                      type="radio"
                      id="customRadio3"
                      name="customRadio3"
                      class="form-check-input"
                      [value]="3"
                      [(ngModel)]="learningObjectiveFilter"
                      (change)="changeLoFilter($event)"
                    />
                    <label class="form-check-label" for="customRadio3"></label>
                  </div>
                  <div class="dropdown-wrapper position-relative d-flex w-100">
                    <button
                      id="dropdownMenuButton3"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      type="button"
                      class="btn btn-white d-flex align-items-center w-100"
                    >
                      <span class="mr-1">LVS-toets: </span>
                      <b>{{ lvsPlaceholder$ | async }}</b
                      ><span class="mdi mdi-chevron-down ml-auto"></span>
                    </button>
                    <ul
                      aria-labelledby="dropdownMenuButton3"
                      class="dropdown-menu"
                      role="menu"
                    >
                      <label
                        role="menuitem"
                        class="form-check-label w-100"
                        for="alletags"
                      >
                        <div class="form-check form-check-inline dropdown-item">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="alletags"
                            value="checkall"
                            (change)="
                              checkUncheckAllTags($event, $event.target.checked)
                            "
                            [checked]="allTagsSelected$ | async"
                          />
                          <label
                            class="form-check-label"
                            (click)="$event.stopPropagation()"
                            for="alletags"
                            >Alle toetsen</label
                          >
                        </div>
                      </label>
                      <label
                        *ngFor="
                          let checkbox of learningObjectiveFilters.tagfilter
                        "
                        role="menuitem"
                        class="form-check-label w-100"
                        [for]="checkbox.name"
                      >
                        <div class="form-check form-check-inline dropdown-item">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="checkbox.name"
                            [checked]="checkbox.checked"
                            (change)="
                              checkUncheckTag(
                                $event,
                                $event.target.checked,
                                checkbox.id
                              )
                            "
                          />
                          <label
                            class="form-check-label"
                            (click)="$event.stopPropagation()"
                            [for]="checkbox.name"
                          >
                            {{ checkbox.name }}</label
                          >
                        </div>
                      </label>
                    </ul>
                  </div>
                </div>
                <div class="btn-group w-100 mb-0">
                  <div class="form-check">
                    <input
                      type="radio"
                      id="customRadio4"
                      name="customRadio4"
                      class="form-check-input"
                      [value]="4"
                      [(ngModel)]="learningObjectiveFilter"
                      (change)="changeLoFilter($event)"
                      [disabled]="
                        !learningObjectiveOrders.myLists ||
                        learningObjectiveOrders.myLists.length === 0
                      "
                    />
                    <label class="form-check-label" for="customRadio4"></label>
                  </div>
                  <div class="dropdown-wrapper position-relative d-flex w-100">
                    <button
                      id="dropdownMenuButton4"
                      [disabled]="
                        !learningObjectiveOrders.myLists ||
                        learningObjectiveOrders.myLists.length === 0
                      "
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      type="button"
                      class="btn btn-white d-flex align-items-center w-100"
                    >
                      <span
                        *ngIf="
                          learningObjectiveData.selectedLearningObjectiveOrder
                            ?.isTemplate
                        "
                        >Eigen lijst</span
                      >
                      <span
                        *ngIf="
                          !learningObjectiveData.selectedLearningObjectiveOrder
                            ?.isTemplate
                        "
                        >{{
                          learningObjectiveData.selectedLearningObjectiveOrder
                            ?.title
                        }}</span
                      >
                      <span class="mdi mdi-chevron-down ml-auto"></span>
                    </button>
                    <ul
                      aria-labelledby="dropdownMenuButton4"
                      class="dropdown-menu"
                      role="menu"
                    >
                      <label
                        role="menuitem"
                        *ngFor="
                          let learningObjectiveOrder of learningObjectiveOrders.myLists
                        "
                        class="form-check-label w-100"
                        [for]="learningObjectiveOrder.id"
                      >
                        <div class="form-check form-check-inline dropdown-item">
                          <input
                            class="form-check-input"
                            type="radio"
                            [id]="learningObjectiveOrder.id"
                            [value]="learningObjectiveOrder.id"
                            [checked]="
                              learningObjectiveOrder.id ===
                              learningObjectiveData
                                .selectedLearningObjectiveOrder?.id
                            "
                            (change)="
                              setSelectedLearningObjectiveOrder(
                                learningObjectiveOrder.id
                              )
                            "
                            (click)="$event.stopPropagation()"
                          />
                          <label
                            class="form-check-label"
                            [for]="learningObjectiveOrder.id"
                            (click)="$event.stopPropagation()"
                          >
                            {{ learningObjectiveOrder.title }}</label
                          >
                        </div>
                      </label>
                    </ul>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="ml-2">
            <button
              type="button"
              class="btn btn-none p-0 m-0 flex-grow-0 flex-shrink-0 position-static"
              popover="Kies het leerdoel dat past bij de manier waarop je Groeimeter wilt inzetten."
              [outsideClick]="true"
              placement="right"
            >
              <img
                class="text-primary"
                src="/assets/icons/questionMarkCircle.svg"
                width="20"
                height="20"
              />
            </button>
          </div>
        </div>

        <div class="btn-group align-items-center w-100 mb-3">
          <button
            id="dropdownMenuButton5"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            type="button"
            class="btn btn-white d-flex align-items-center"
          >
            <span class="mr-1">Jaargroep:</span>
            <b>{{ gradePlaceholder$ | async }}</b
            ><span class="mdi mdi-chevron-down ml-auto"></span>
          </button>
          <button
            type="button"
            class="btn btn-none p-0 m-0 flex-grow-0 flex-shrink-0"
            popover="Kies hier het niveau van de gewenste leerdoelen."
            [outsideClick]="true"
            placement="right"
          >
            <img
              class="text-primary"
              src="/assets/icons/questionMarkCircle.svg"
              width="20"
              height="20"
            />
          </button>
          <ul
            aria-labelledby="dropdownMenuButton5"
            class="dropdown-menu"
            role="menu"
          >
            <label
              role="menuitem"
              class="form-check-label w-100"
              for="allegroepen"
            >
              <div class="form-check form-check-inline dropdown-item">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="allegroepen"
                  value="checkall"
                  (change)="
                    checkUncheckAllGroups($event, $event.target.checked)
                  "
                  [checked]="allGradeLevelsSelected$ | async"
                />
                <label
                  class="form-check-label"
                  (click)="$event.stopPropagation()"
                  for="allegroepen"
                >
                  Alle groepen</label
                >
              </div>
            </label>
            <label
              *ngFor="let checkbox of learningObjectiveFilters.gradelevelfilter"
              role="menuitem"
              class="form-check-label w-100"
              [for]="checkbox.name"
            >
              <div class="form-check form-check-inline dropdown-item">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="checkbox.name"
                  [checked]="checkbox.checked"
                  (change)="
                    checkUncheckGroup(
                      $event,
                      $event.target.checked,
                      checkbox.id
                    )
                  "
                />
                <label
                  class="form-check-label"
                  (click)="$event.stopPropagation()"
                  [for]="checkbox.name"
                >
                  {{ checkbox.name }}</label
                >
              </div>
            </label>
          </ul>
        </div>
        <div class="btn-group align-items-center w-100 mb-3">
          <button
            id="dropdownMenuButton6"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            type="button"
            class="btn btn-white d-flex align-items-center"
          >
            <span class="mr-1">Domein: </span>
            <b>{{ domainPlaceholder$ | async }}</b
            ><span class="mdi mdi-chevron-down ml-auto"></span>
          </button>
          <button
            type="button"
            class="btn btn-none p-0 m-0 flex-grow-0 flex-shrink-0"
            popover="Kies hier het domein waarop je wilt toetsen."
            [outsideClick]="true"
            placement="right"
          >
            <img
              class="text-primary"
              src="/assets/icons/questionMarkCircle.svg"
              width="20"
              height="20"
            />
          </button>
          <ul
            aria-labelledby="dropdownMenuButton6"
            class="dropdown-menu"
            role="menu"
          >
            <label
              role="menuitem"
              class="form-check-label w-100"
              for="alledomeinen"
            >
              <div class="form-check form-check-inline dropdown-item">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="alledomeinen"
                  value="checkall"
                  (change)="
                    checkUncheckAllDomains($event, $event.target.checked)
                  "
                  [checked]="allDomainsSelected$ | async"
                />
                <label
                  class="form-check-label"
                  (click)="$event.stopPropagation()"
                  for="alledomeinen"
                >
                  Alle domeinen</label
                >
              </div>
            </label>
            <label
              *ngFor="let checkbox of learningObjectiveFilters.domainfilter"
              role="menuitem"
              class="form-check-label w-100"
              [for]="checkbox.name"
            >
              <div class="form-check form-check-inline dropdown-item">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="checkbox.name"
                  [checked]="checkbox.checked"
                  (change)="
                    checkUncheckDomain(
                      $event,
                      $event.target.checked,
                      checkbox.id
                    )
                  "
                />
                <label
                  class="form-check-label"
                  (click)="$event.stopPropagation()"
                  [for]="checkbox.name"
                >
                  {{ checkbox.name }}</label
                >
              </div>
            </label>
          </ul>
        </div>

        <ng-container *ngIf="(selectedCitoModule$ | async) === 0">
          <ng-container
            *ngIf="
              learningObjectiveData.subjectsInLearningObjectives &&
              learningObjectiveData.subjectsInLearningObjectives.length > 0
            "
          >
            <div class="btn-group align-items-center w-100 mb-3">
              <button
                id="dropdownMenuButton7"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                type="button"
                class="btn btn-white d-flex align-items-center"
              >
                <span class="mr-1">Onderwerp:</span>
                <b>{{ getSubjectPlaceholder$ | async }}</b>
                <span class="mdi mdi-chevron-down ml-auto"></span>
              </button>
              <button
                type="button"
                class="btn btn-none p-0 m-0 flex-grow-0 flex-shrink-0"
                popover="Kies het onderwerp of de onderwerpen waarop je wilt toetsen."
                [outsideClick]="true"
                placement="right"
              >
                <img
                  class="text-primary"
                  src="/assets/icons/questionMarkCircle.svg"
                  width="20"
                  height="20"
                />
              </button>
              <ul
                aria-labelledby="dropdownMenuButton7"
                class="dropdown-menu"
                role="menu"
              >
                <label
                  role="menuitem"
                  class="form-check-label w-100"
                  for="alleonderwerpen"
                >
                  <div class="form-check form-check-inline dropdown-item">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="alleonderwerpen"
                      value="checkall"
                      (change)="checkUncheckAllSubjects($event)"
                      [checked]="allSubjectsChecked"
                    />
                    <label
                      class="form-check-label"
                      (click)="$event.stopPropagation()"
                      for="alleonderwerpen"
                    >
                      Alle onderwerpen</label
                    >
                  </div>
                </label>
                <label
                  *ngFor="let checkbox of subjectsInList$ | async"
                  role="menuitem"
                  class="form-check-label w-100"
                  [for]="checkbox.id"
                >
                  <label
                    class="form-check form-check-inline dropdown-item"
                    [for]="'subject-filter' + checkbox.id"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'subject-filter' + checkbox.id"
                      [checked]="checkbox.checked"
                      (change)="checkUncheckSingleSubject(checkbox, $event)"
                      [disabled]="
                        !loPresent(
                          checkbox,
                          learningObjectiveData.visibleSubjects
                        )
                      "
                    />
                    <label
                      class="form-check-label"
                      (click)="$event.stopPropagation()"
                      [for]="'subject-filter' + checkbox.id"
                    >
                      {{ checkbox.name }}</label
                    >
                  </label>
                </label>
              </ul>
            </div>
          </ng-container>
        </ng-container>
        <div class="btn-group mt-auto">
          <button
            (click)="resetFilters()"
            class="btn btn-gray-light mdi mdi-close"
          >
            Filters wissen
          </button>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<input
  *ngIf="router.includes('/domains')"
  class="form-control border-primary flex-grow-1 ml-2"
  [ngModelOptions]="{ standalone: true }"
  [placeholder]="'Zoek in ' + placeholdertext"
  [ngModel]="searchText"
  (ngModelChange)="changed($event)"
  (focus)="focus($event)"
/>
